__turbopack_context__.v({
  "interactiveRow": "styles-module__HEldXG__interactiveRow",
  "selectedRow": "styles-module__HEldXG__selectedRow",
  "table": "styles-module__HEldXG__table",
});
